import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setMarketByRegion } from 'Store/Organization/MarketByRegion/MarketByRegionAction';
import { GET_MARKET_BY_REGION } from 'Store/Organization/MarketByRegion/MarketByRegionType';
import { apiMethod, apiType, API_URL } from 'utils';
import OrganizationApiService from './OrganizationApiService';
import { IPayload } from 'Model/IPayload';

function* getMarketByRegion(req?: any): any {
    let payloadData : IPayload = {                
        apiMethod : apiMethod.GET,
        apiType : apiType.Organization,
        endpoint : `organizations/dropdown/market/${req.regionId}`,   
        payload : null    
    }
    try {
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(
            OrganizationApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setMarketByRegion(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* watchGetStates() {
    yield takeEvery(GET_MARKET_BY_REGION, getMarketByRegion)
}

export default function* combinedSaga() {
    yield all([
        watchGetStates()
    ])
}
